import { render, staticRenderFns } from "./EmployeeSearch.vue?vue&type=template&id=fec4d38a&scoped=true"
import script from "./EmployeeSearch.vue?vue&type=script&lang=ts"
export * from "./EmployeeSearch.vue?vue&type=script&lang=ts"
import style0 from "./EmployeeSearch.vue?vue&type=style&index=0&id=fec4d38a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fec4d38a",
  null
  
)

export default component.exports